'use strict';

angular.module('msCommunity').controller('CommunityHomeCtrl', ['topics', '$log', function (topics, $log) {
  var vm = this;
  vm.select = function (topic) {
    $log.debug('Community Home Topic: ', topic);
    vm.showdd = false;
    vm.selected = topic;
  };
  vm.topics = topics;
  // set the default ALL category
  vm.selected = _.find(topics, function (cat) {
    return cat.shortName === 'ALL';
  });
}]);